module.exports = __webpack_public_path__ + "static/4-598df07364fa5e7c5bbd24db6a747730.jpg";